import React from "react";
import { ThreeDots } from "react-loader-spinner";
import "./SmallLoader.css";

const SmallLoader = () => {
  return (
    <>
      <div className="smallloadersection">
        <ThreeDots
          height="100"
          width="100"
          color="#424858"
          wrapperStyle={{}}
          wrapperClass=""
          visible={true}
          outerCircleColor=""
          innerCircleColor=""
          barColor=""
          ariaLabel="circles-with-bar-loading"
        />
      </div>
    </>
  );
};

export default SmallLoader;
